import { API } from "@thenounproject/lingo-core";
import { createAsyncAction } from "../actionCreators";

type Args = {
  spaceId: number;
  email: string;
};

const [useAddSpaceEmailDomain, addSpaceEmailDomain] = createAsyncAction(
  "spaces/addSpaceEmailDomain",
  async ({ spaceId, email }: Args) => {
    const res = await API.call<{ space: number }>({
      endpoint: `spaces/${spaceId}/domains`,
      method: "POST",
      data: { email },
    });
    return { ...res, result: res.result.space };
  }
);

export default useAddSpaceEmailDomain;
export { addSpaceEmailDomain };
